import { gql } from '@apollo/client/core';

export const CORE_USER_FIELDS = gql`
  fragment user on UsersClients {
    id
    userName
    firstName
    lastName
    caseNumber
    passwordResetAllowed
    passwordLastUpdated
    active
    createdBy
    createdAt
    updatedBy
    updatedAt
    identityUserId
    isUser
    role
    groupId
    accessLevel
    phone
    ext
    pin
    cellPhone
    accounts {
      account {
        name
      }
      accountNumber
    }
    applications {
      application {
        code
        description
      }
    }
    groups {
      group {
        groupId
        name
      }
    }
    permissions {
      permissionId
      name
    }
  }
`;

/** This query to get users. */
export const getUsersQuery = gql`
  query GetUsers(
    $first: Int!
    $where: UsersClientsFilterInput
    $order: [UsersClientsSortInput!]
    $after: String
  ) {
    users(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...user
      }
    }
  }
  ${CORE_USER_FIELDS}
`;

export const getUsersWithSameAccessQuery = gql`
  query GetUsersWithSameAccess(
    $first: Int!
    $where: UsersClientsFilterInput
    $order: [UsersClientsSortInput!]
    $after: String
  ) {
    usersWithSameAccess(
      first: $first
      where: $where
      order: $order
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...user
      }
    }
  }
  ${CORE_USER_FIELDS}
`;

/** This query to get single user. */
export const getUserQuery = gql`
  query GetUser($id: Int!) {
    user(id: $id) {
      ...user
    }
  }
  ${CORE_USER_FIELDS}
`;

/** This query to get user details for currently logged in user, using token information. */
export const getLogginedUserQuery = gql`
  query GetLogginedUser {
    loggedInUser {
      ...user
    }
  }
  ${CORE_USER_FIELDS}
`;

export const getUsersByGroups = gql`
  query getUsersByGroups(
    $first: Int!
    #$where: UsersClientsFilterInput,
    $after: String
    $groups: [String]
  ) {
    usersByGroup(first: $first, after: $after, groups: $groups) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        firstName
        lastName
        userName
        accessLevel
        applications {
          applicationId
          name
        }
        accounts {
          account
          name
        }
        groups {
          groupId
          name
        }
        permissions {
          id
          name
        }
      }
    }
  }
`;

export const getUsersPermissionsQuery = gql`
  query GetUsersWithSameAccess(
    $first: Int!
    $where: UsersClientsFilterInput
    $order: [UsersClientsSortInput!]
    $after: String
  ) {
    usersWithSameAccess(
      first: $first
      where: $where
      order: $order
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        userName
        firstName
        lastName
        permissions {
          permissionId
          name
        }
      }
    }
  }
`;
